import useBoundStore from 'store';
import { AppMode } from 'hooks/use-app-mode';

export const useApartmentSearch = (appMode: AppMode) =>
  useBoundStore((s) => (appMode === 'buy' ? s.buyApartmentSearch : s.sellApartmentSearch));

export const useSetApartmentSearch = (appMode: AppMode) =>
  useBoundStore((s) => (appMode === 'buy' ? s.setBuyApartmentSearch : s.setSellApartmentSearch));

export const useSelectComplex = (appMode: AppMode) =>
  useBoundStore(
    (s) => (id: number, title?: string) =>
      appMode === 'buy'
        ? s.toggleComplexSelection(id)
        : s.setSelectedSellComplex({ id, title: title! }),
  );
